import { render, staticRenderFns } from "./ccga.vue?vue&type=template&id=12051dad&"
import script from "./ccga.vue?vue&type=script&lang=js&"
export * from "./ccga.vue?vue&type=script&lang=js&"
import style0 from "./ccga.vue?vue&type=style&index=0&media=screen&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports